import { useFormik } from 'formik';
import { initialValues } from './formData';
import { cleanObj } from '../../../../../shared/utils/objects';
import { AccountFilter } from '../../../../../shared/types/modules/account';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { asyncGetParams } from '../../../../../services/param.service';
import { useParams } from 'react-router-dom';

export const useAccountFilters = (onFilter?: (data: AccountFilter) => void) => {
    const { documentAccount } = useParams();

    const [typesDocument, setTypesDocument] = useState<ISelect[]>([]);
    const onSubmit = (data: AccountFilter) => {
        if (onFilter) onFilter(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues: {
            ...initialValues,
            document: documentAccount?.trim() || '',
        },
        onSubmit,
    });

    useEffect(() => {
        if (
            formik?.values?.document &&
            formik?.values?.document === documentAccount?.trim()
        ) {
            formik?.submitForm();
        }
    }, [documentAccount, formik?.values?.document]);

    useEffect(() => {
        asyncGetParams(ParamEnum.DOCUMENT_TYPE).then((params) =>
            setTypesDocument(params)
        );
    }, []);

    return {
        formik,
        typesDocument,
    };
};
